import { useSearchParams } from 'react-router-dom';
import constants from '../constants/Constants';

export default function useProductFilters() {
  const [searchParams, setSearchParams] = useSearchParams();
  const categories = searchParams.getAll('category');
  const activeTabs = Object.values(constants.TABS).filter((tab) =>
    categories.includes(tab.toLowerCase())
  );

  const setActiveTabs = (tabs: string[]) => {
    setSearchParams((previous) => {
      const next = new URLSearchParams(previous);
      next.delete('category');
      tabs.forEach((tab) => next.append('category', tab.toLowerCase()));
      return next;
    }, { replace: true });
  };

  return { activeTabs, setActiveTabs };
}
